/**
 * FBSBancaRIOBAMBA
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CuentaModeloMSL { 
    secuencial?: number;
    codigo?: string;
    tipo?: string;
    estado?: string;
    saldoCuenta?: number;
    oficina?: string;
    fechaApertura?: string;
    moneda?: string;
    bloqueaTransaccionOperativa?: boolean;
}

